import googleLoginWithFireBase from '../../Data/Services/firebase';
import loginWithProvider from '../loginWithProvider';

export default async function loginWithGoogle() {
  const googleData = await googleLoginWithFireBase();

  return loginWithProvider(googleData.token, 'google');
}
